export const getActivityAttributeOptions = `
  query ActivityAttributeOptions($id: Int!, $searchString: String, $limit: Int) {
    activityAttributeOption(activityAttributeId: $id, searchString: $searchString, limit: $limit) {
      id
      optionName
      isDefault
    }
  }
`;

export interface ActivityAttributeOption {
  id: string;
  optionName: string;
  isDefault: boolean;
}

export interface GetActivityAttributeOptionsResponse {
  activityAttributeOption: ActivityAttributeOption[];
}
